import { useMemo, useEffect } from "react";
import { debounce } from "lodash";
import Datetime from "react-datetime";
import moment from "moment";
import { Row, Col } from "react-bootstrap";

export default function FilterComponent({
    filter,
    onChange,
    onClear,
}) {
    // Debounced search inputs
    const debouncedUserChange = useMemo(() => debounce((val) => {
        onChange({ target: { name: "search", value: val } });
    }, 300), []);

    const debouncedIpChange = useMemo(() => debounce((val) => {
        onChange({ target: { name: "ip", value: val } });
    }, 300), []);

    const debouncedEndpointChange = useMemo(() => debounce((val) => {
        onChange({ target: { name: "endpoint", value: val } });
    }, 300), []);

    useEffect(() => {
        return () => {
            debouncedIpChange.cancel();
            debouncedEndpointChange.cancel();
            debouncedUserChange.cancel();
        };
    }, []);


    return (
        <div className="fillte_main">
            <div className="filter_name">Filter By:</div>
            <div className="center_fillter mt-3">
                <Row className="justify-content-end">
                    <Col lg={6}>
                        <label className="mb-2">Search User:</label>
                        <input
                            type="text"
                            name="ip"
                            placeholder="Search User"
                            defaultValue={filter.search || ""}
                            onChange={(e) => debouncedUserChange(e.target.value)}
                            className="form-control"
                        />
                    </Col>
                    <Col lg={6}>
                        {/* IP Address (Debounced) */}
                        <label className="mb-2">IP Address:</label>
                        <input
                            type="text"
                            name="ip"
                            placeholder="IP Address"
                            defaultValue={filter.ip || ""}
                            onChange={(e) => debouncedIpChange(e.target.value)}
                            className="form-control"
                        />
                    </Col>

                    <Col lg={6}>

                        {/* Status Code (Dropdown) */}
                        <label className="mb-2">Status Code:</label>

                        <select
                            name="statusCode"
                            value={filter.statusCode || ""}
                            onChange={onChange}
                            className="form-control"
                        >
                            <option value="">Status Code</option>
                            <option value="200">200</option>
                            <option value="400">400</option>
                            <option value="4001">4001</option>
                            <option value="5002">5002</option>
                            <option value="5003">5003</option>
                            <option value="5004">5004</option>
                        </select>
                    </Col>


                    <Col lg={6}>
                        {/* Method (Dropdown) */}
                        <label className="mb-2">Method:</label>

                        <select
                            name="method"
                            value={filter.method || ""}
                            onChange={onChange}
                            className="form-control"
                        >
                            <option value="">Method</option>
                            <option value="GET">GET</option>
                            <option value="POST">POST</option>
                            <option value="PATCH">PATCH</option>
                            <option value="DELETE">DELETE</option>
                        </select>

                    </Col>

                    <Col lg={6}>
                        {/* Endpoint (Debounced) */}
                        <label className="mb-2">Endpoint:</label>

                        <input
                            type="text"
                            name="endpoint"
                            placeholder="Endpoint"
                            defaultValue={filter.endpoint || ""}
                            onChange={(e) => debouncedEndpointChange(e.target.value)}
                            className="form-control"
                        />
                    </Col>



                    <Col lg={3}>
                        {/* Start Date Picker */}
                        <div className="form-group m-0">
                            <label className="me-2">Start Date:</label>
                            <Datetime
                                value={filter.startDate ? moment(filter.startDate) : ""}
                                inputProps={{ placeholder: "YYYY-MM-DD", readOnly: true, className: "form-control" }}
                                dateFormat="YYYY-MM-DD"
                                timeFormat={false}
                                onChange={(date) =>
                                    onChange({ target: { name: "startDate", value: moment(date).format("YYYY-MM-DD") } })
                                }
                                isValidDate={(current) => current.isSameOrBefore(moment())}
                            />
                        </div>
                    </Col>


                    <Col lg={3}>

                        {/* End Date Picker */}
                        <div className="form-group m-0">
                            <label className="me-2">End Date:</label>
                            <Datetime
                                value={filter.endDate ? moment(filter.endDate) : ""}
                                inputProps={{ placeholder: "YYYY-MM-DD", readOnly: true, className: "form-control" }}
                                dateFormat="YYYY-MM-DD"
                                timeFormat={false}
                                onChange={(date) =>
                                    onChange({ target: { name: "endDate", value: moment(date).format("YYYY-MM-DD") } })
                                }
                                isValidDate={(current) => current.isSameOrBefore(moment())}
                            />
                        </div>
                    </Col>


                    <Col lg={6}>
                        {/* Clear Button */}
                        <button className="btn btn-sm btn-gradient-primary w-100 py-3" onClick={onClear}>
                            Clear
                        </button>
                    </Col>



                </Row>



            </div>
        </div>
    );
}
